import * as React from 'react';
import { KonkurrenceOverblikEkstern } from '../../../models/KonkurrenceOverblikEkstern';
import KonkurrenceOverblikEksternPresenter from './KonkurrenceOverblikEksternPresenter';

export interface KonkurrenceOverblikEksternContainerProps {
    konkurrenceId?: string;
    isLaererSkrivebord: boolean;
    konkurrenceOverblik?: KonkurrenceOverblikEkstern;
}

interface KonkurrenceOverblikEksternContainerState {

}

class KonkurrenceOverblikEksternContainer extends React.Component<KonkurrenceOverblikEksternContainerProps, KonkurrenceOverblikEksternContainerState> {
    constructor(props: KonkurrenceOverblikEksternContainerProps) {
        super(props);

        this.state = {
            
        };
    }

    render() {
        let content = undefined;
        content = (
            <div className='konkurrence-overblik-ekstern-container'>
                {this.props.konkurrenceOverblik !== undefined &&
                    <KonkurrenceOverblikEksternPresenter
                        konkurrencetitel={this.props.konkurrenceOverblik.konkurrenceTitel}
                        konkurrenceDate={this.props.konkurrenceOverblik.konkurrenceDate}
                        konkurrenceAfviklingssted={this.props.konkurrenceOverblik.konkurrenceAfviklingssted}
                        konkurrenceId={this.props.konkurrenceOverblik.konkurrenceId}
                        billedId={this.props.konkurrenceOverblik.billedId}
                        opgaver={this.props.konkurrenceOverblik.opgaver}
                        beskrivelse={this.props.konkurrenceOverblik.beskrivelse}
                        opgaverSynligFra={this.props.konkurrenceOverblik.opgaverSynligFra}
                        opgavepakker={this.props.konkurrenceOverblik.opgavepakker}
                    />
                }
            </div>

        );

        return (
            <div>
                {content}
            </div>
        );
    }
}

export default KonkurrenceOverblikEksternContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/konkurrenceOverblik/KonkurrenceOverblikEksternContainer.tsx